import React from 'react'
import PropTypes from "prop-types";
import {starRatingRequest} from "../../../../../../helpers/requests";
import { Loader } from "../../../../../common/elements/index";

class StarRating extends React.Component {
    constructor(props) {
        super(props);
        this._isMounted = false;
        this.state = {
            starRating: null
        }
    }

    componentWillMount() {
        this._isMounted = true;
       
        starRatingRequest(this.props.personId).then((result, i) => {
        if (this._isMounted)
        {this.setState({ starRating: result})}
        })
    }

    componentWillUnmount() {
        this._isMounted = false;
    }
    

    starArray = (numberOfStars) => {
        let starArray = [];
        for(let i = 0; i < numberOfStars; i++) {
            starArray.push(i+1);
        }
        return starArray;
    };

    render() {
        return (
            <div className="stars-list-whole">
                {this.state.starRating === 0 || this.state.starRating ?
                    <ul className="star-list">
                        {this.starArray(this.state.starRating).map((star, i) => {
                            return (
                                <li key={i} className="star-list-item">
                                    <img className="star-item-image" src="/images/icons-new/star.svg"/>
                                </li>
                            );
                        })}
                        {this.starArray((10 - this.state.starRating)).map((star, i) => {
                            return (
                                <li key={i} className="star-list-item">
                                    <img className="star-item-image" src="/images/icons-new/star-grey.svg"/>
                                </li>
                            );
                        })}
                    </ul>
                    :
                    <Loader/>}
            </div>
        )
    }
}

export default StarRating;

StarRating.propTypes = {
    personId: PropTypes.any
};



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/header/StarRating.js